import React from 'react';
import { translate } from 'react-i18next';
import ArrowRightSmall from 'wix-ui-icons-common/ArrowRightSmall';
import { Link } from 'react-router-dom';
import { TextButton } from 'wix-style-react';
import { ARENA_PROFILE_PAGE_URL } from '../../../../utils/constants';

const ViewProfileCta = ({ t, onClick, id, username, reviewsScore }) => {
  return (
    <TextButton
      as={Link}
      to={`${ARENA_PROFILE_PAGE_URL}/${username}`}
      onClick={() => onClick && onClick(id, username, reviewsScore)}
      suffixIcon={<ArrowRightSmall />}
      weight="normal"
      dataHook="expert-card-view-profile"
    >
      {t('client-exploreexperts-view-profile')}
    </TextButton>
  );
};

export default translate()(ViewProfileCta);
